import { render, staticRenderFns } from "./ylkt8.vue?vue&type=template&id=6f99517e&scoped=true&"
import script from "./ylkt8.vue?vue&type=script&lang=js&"
export * from "./ylkt8.vue?vue&type=script&lang=js&"
import style0 from "./ylkt8.vue?vue&type=style&index=0&id=6f99517e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f99517e",
  null
  
)

export default component.exports